import { render, staticRenderFns } from "./generate-prototype.vue?vue&type=template&id=899447f6&scoped=true&"
import script from "./generate-prototype.vue?vue&type=script&lang=js&"
export * from "./generate-prototype.vue?vue&type=script&lang=js&"
import style0 from "./generate-prototype.vue?vue&type=style&index=0&id=899447f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899447f6",
  null
  
)

component.options.__file = "generate-prototype.vue"
export default component.exports